import { Link } from '@remix-run/react'
import { cn } from '#app/utils/misc.tsx'
import { LogoMark } from './logo-mark.tsx'

export const Logo = ({
	mode = 'stuck',
	to = '/',
	size = 'lg',
}: {
	mode?: 'stuck' | 'follow-theme'
	to?: string
	size?: 'md' | 'lg'
}) => {
	return (
		<Link
			to={to}
			aria-label={to === '/' ? 'ReefChronicles home' : 'ReefChronicles'}
			className="inline-flex items-center gap-2.5 leading-none"
		>
			<LogoMark className={size === 'lg' ? 'h-9 w-9' : 'h-8 w-8'} />
			<span
				className={cn(
					'font-bold tracking-tight',
					size === 'lg' ? 'text-2xl' : 'text-lg',
					mode === 'stuck' ? 'text-white' : 'text-foreground',
				)}
			>
				ReefChronicles
			</span>
		</Link>
	)
}
